//AzeemKhan : 04-07-2023 : BT-107432 -  Breeze - Alerts - Start
import { memo, } from "react";
import { useDispatch } from "react-redux";
import { handleModal, handleModalData } from "../../redux/actions/modals";
import { toastConfig } from "../../redux/actions/toast";
import { convertAlertToWatchlistGrid, getApiExchangeNameFromMktSegId, getDynamicParamsForToFixed, getScripDisplayDescription } from "../../utils/global_functions";
import { Col, Container, Row } from "react-bootstrap";

const AlertGridDetails = ({ setArrSelectedDeleteAlert, bIseditButtonShow, ...props }) => {
    const dispatch = useDispatch();
    const handleEditAlert = (data) => {
        dispatch(handleModalData({
            AlertData: {
                symbol: data?.symbol,
                exchange: data?.exchange,
                series: data?.series,
                description: getScripDisplayDescription(convertAlertToWatchlistGrid(data)),
                token: data?.nToken,
                mktId: data?.segmentId,
                decimalLocator: data?.decimalLocator,
                decimalLocator_length: getDynamicParamsForToFixed(data?.exchange),
                exchange_segement: getApiExchangeNameFromMktSegId(data?.segmentId)


            }, modifyData: data, isEditable: true
        }));
        dispatch(handleModal([{ "SET_ALERT_MODAL": true }]));
    };
    const handleSingleAlertDelete = (data) => {
        setArrSelectedDeleteAlert([data]);
        dispatch(toastConfig({ show: true, message: <div className='d-flex justify-content-start align-items-center'>Remove Selected Alerts <div className='notification-count font-regular mx-2'>01</div></div>, button: [{ btnName: "Close", type: "CLOSE_REMOVE_ALERT_TOASTER", className: "btn btn-outline-active ms-3" }, { btnName: "Remove Alert", type: "REMOVE_ALERT", className: "btn btn-light ms-3" }] }));
    };
    return (
        <>
            <Container fluid className='p-0'>
                <Row className='g-0'>
                    <Col className='d-flex justify-content-center mt-3'>
                        <div className='icon-16 icon-delete icon-dark ms-3' onClick={handleSingleAlertDelete.bind(this, props?.node?.data)} ></div>
                        {bIseditButtonShow && <div className='icon-16 icon-edit icon-dark ms-3' onClick={handleEditAlert.bind(this, props?.node?.data)}></div>}
                    </Col>
                </Row>
            </Container>
        </>
    );
};
export default memo(AlertGridDetails);
//AzeemKhan : 04-07-2023 : BT-107432 -  Breeze - Alerts - End